const en = {
  "hotel.folio.guest": "Guests",
  "hotel.folio.guest.name": "Name",
  "hotel.folio.guest.birthday": "Birth Date",
  "hotel.folio.guest.id_number": "ID Number",
  "hotel.folio.guest.sex": "Gender",
  "hotel.folio.guest.nationality": "Nationality",
  "hotel.folio.guest.target_country": "Destination Country",
  "hotel.folio.guest.email": "Email",
  "hotel.folio.guest.Nombres": "Full name",
  "hotel.folio.guest.typeDocument": "Document Type",
  "hotel.folio.guest.type_accomodation": "Accommodation Type",
  "hotel.folio.guest.room": "Room",
  "hotel.folio.guest.phone": "Phone",
  "hotel.folio.guest.arrival_date": "Check-in Date",
  "hotel.folio.guest.departure_date": "Check-out Date",
  "hotel.folio.guest.nights_quantity": "Number of Nights",
  "hotel.folio.guest.unit_price": "Rate / Unit Price",
  "hotel.folio.guest.payment_status": "Payment Status",
  "hotel.folio.guest.channel": "Booking Channel",
  "hotel.folio.guest.reason": "Travel Reason",
  "hotel.folio.guest.Tipo de Ocupante": "Occupant Type",
  "hotel.folio.guest.company": "Company",
  "hotel.folio.guest.Identificación Empresa": "Company ID",
  "hotel.folio.guest.vehicle_plate": "Vehicle Plate",
  "hotel.folio.guest.adult": "Adult",
  "hotel.folio.guest.child": "Child",
  male: "Male",
  female: "Female",
  "hotel.folio.guest.main_guest": "Main Guest",
  "hotel.folio.guest.type_guest": "Guest Type",
  "hotel.folio.guest.type_document": "Document Type",
  "hotel.folio.guest.mobile": "Mobile",
  "hotel.folio.guest.address": "Address",
  "hotel.folio.guest.origin_country": "Country of Origin",
  "hotel.folio.guest.notes": "Notes",
  "hotel.folio.guest.registro_civil": "Civil Birth Registry",
  "hotel.folio.guest.tarjeta_identidad": "Identity Card",
  "hotel.folio.guest.cedula_ciudadania": "Citizenship Card",
  "hotel.folio.guest.tarjeta_extranjeria": "Foreigner ID Card",
  "hotel.folio.guest.cedula_extranjeria": "Foreigner Citizenship Card",
  "hotel.folio.guest.nit": "Tax ID (NIT)",
  "hotel.folio.guest.add_guest": "Add",
  "hotel.folio.guest.cancel": "Cancel",
  "hotel.folio.guest.pasaporte": "Passport",
  "hotel.folio.guest.tipo_documento_extranjero": "Foreign Document Type",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "Foreign Tax ID (NIT)",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "Country",
  "hotel.folio.guest.subdivision": "Subdivision",
  "hotel.booking.link_web_checkin": "Check-in Link",
  "hotel.folio.guest.city_co": "City",
  "hotel.folio.guest.foreign_city": "Foreign City",
  "hotel.folio.guest.welcome_tra":
    "Let's sign the Accommodation Registration Card (ARC)",
  "hotel.folio.guest.hello": "Hello",
  hotel_tra_register_card: "Accommodation Registration Card (ARC)",
  "msg-introduction":
    "We are going to sign the Accommodation Registration Card (ARC).",
  "hotel.folio.guest.title-modal-select-lan": "Select language",
  "hotel.folio.guest.btn_finish": "FINISH",

  "hotel.folio.guest.content_guest": "Guests",
  "hotel.folio.guest.content_info_folio": "Main Guest Information",
  "hotel.folio.guest.content_contract": "Lodging Contract",
  "hotel.folio.guest.content_signature": "Digital Signature",
  "hotel.folio.guest.terms_and_conditions1":
    " I have read and accept the terms and conditions of the lodging contract",
  "hotel.folio.guest.terms_and_conditions2":
    " and the establishment’s personal data processing policy",
  "hotel.folio.guest.guests_no_found": "No guests found",
  "hotel.folio.guest.accept_contract":
    "You are missing to accept the lodging contract",
  "hotel.folio.signature.updated": "Signature updated correctly",
  "hotel.folio.guest.finish": "Welcome to the hotel!",
  "hotel.folio.guest.finish_tra": "Thank you for registering digitally!",
  "hotel.folio.guest.finish_description":
    "With this small gesture, you helped reduce paper usage and take care of the planet. Every action counts.",
  "app.webcheckin.melhos.use_app":
    "You can use our App! Cool thing is, no download needed 😎",
};
export default en;
